import { currencyFormat } from "@/validator/globalvalidator";

export default function currencyFilter(value: number): string {
  return currencyFormat(value) || "0.00";
}
